import { useSelector } from 'react-redux';
import CryptoPriceChange from './CryptoPriceChange';
import PropTypes from 'prop-types';

const StatsBlock = ({ label, value }) => {
    return (
        <div className="w-44 px-2.5 py-3 bg-card-bg rounded-md inline-flex flex-col justify-center items-center gap-1 overflow-hidden !grow">
            <div className="text-center justify-start text-[#70707B] dark:text-[#D1D1D6] text-sm font-semibold leading-tight uppercase">
                {label}
            </div>
            <div className="text-center justify-start !text-text text-sm font-semibold  leading-tight">
                {value}
            </div>
        </div>
    );
};

StatsBlock.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]).isRequired,
};

const CryptoStatsMobile = ({ currency }) => {
    const cryptoStats = useSelector(state => state.juno.cryptoStats);
    const selectedCrypto = cryptoStats?.find(stat => stat.symbol?.toUpperCase() == currency);

    if (!selectedCrypto) {
        return null;
    }

    const renderData = [
        {
            label: 'price',
            value: <span>${parseFloat(selectedCrypto?.current_price?.toFixed(2))}</span>,
        },
        {
            label: 'market cap',
            value: selectedCrypto?.market_cap,
        },
        {
            label: 'change 24h',
            value: (
                <CryptoPriceChange
                    value={selectedCrypto?.price_change_percentage_24h}
                    valueStyle={'!text-text font-semibold'}
                />
            ),
        },
    ];

    return (
        <div className="bg-[#fff] dark:bg-[#26272B] my-1 rounded-sm">
            <div className="self-stretch px-4 pt-4 inline-flex justify-start items-center gap-2">
                <div className="flex-1 flex justify-start items-center gap-1">
                    <div className="justify-start text-profile-primary text-sm font-semibold leading-tight uppercase">
                        {selectedCrypto?.name} STATISTICS
                    </div>
                </div>
            </div>
            <div className="self-stretch px-4 pt-3 pb-4 inline-flex justify-start items-start gap-1.5 flex-wrap content-start w-full">
                {renderData?.length ? renderData.map(props => <StatsBlock {...props} />) : null}
            </div>
        </div>
    );
};

export default CryptoStatsMobile;
